import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store'
import { Provider } from 'react-redux'
import { client } from './apollo/client';

Sentry.init({
  enabled: process.env.SENTRY_ENABLED === 'true',
  environment: process.env.SENTRY_ENV,
  release: `${process.env.APP_VERSION}`,
  dsn: 'https://aaa83295c0bc7e8f44f8a5d258e6c674@o4509031538819072.ingest.de.sentry.io/4509031549829200',
  initialScope: {
    tags: {
      customer: process.env.CUSTOMER,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
